/**
 * @generated SignedSource<<39dd5a3cf917a5516959c8e12528b074>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileSettingsProfileFormFieldsFragment$data = {
  readonly defaultFields: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isPrivate: boolean;
        readonly title: string;
      };
    }>;
  };
  readonly " $fragmentType": "ProfileSettingsProfileFormFieldsFragment";
};
export type ProfileSettingsProfileFormFieldsFragment$key = {
  readonly " $data"?: ProfileSettingsProfileFormFieldsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileSettingsProfileFormFieldsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileSettingsProfileFormFieldsFragment",
  "selections": [
    {
      "alias": "defaultFields",
      "args": [
        {
          "kind": "Literal",
          "name": "isDefault",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "status",
          "value": "visible"
        }
      ],
      "concreteType": "ProfileFieldNodeConnection",
      "kind": "LinkedField",
      "name": "profileFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileFieldNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileField",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPrivate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "profileFields(isDefault:true,status:\"visible\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "7301c9dfcdf6e8611ec49907aeb64595";

export default node;
